import { render, staticRenderFns } from "./scope12.vue?vue&type=template&id=3120c874"
import script from "./scope12.vue?vue&type=script&lang=js"
export * from "./scope12.vue?vue&type=script&lang=js"
import style0 from "./scope12.vue?vue&type=style&index=0&id=3120c874&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports